
const scrollIntoViewOnRefChange = (node: HTMLElement | null) => node?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })

export default scrollIntoViewOnRefChange